import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const AllergenFallback = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="AllergenFallback" viewBox="0 0 64 64" {...rest}>
      <rect width="64" height="64" rx="32" fill="black" fillOpacity="0.07" />
      <path
        d="M30.2279 18.0231C31.0155 16.659 32.9845 16.659 33.7721 18.0231L48.7213 43.9159C49.5089 45.2801 48.5244 46.9853 46.9492 46.9853H17.0508C15.4756 46.9853 14.4911 45.2801 15.2787 43.9159L30.2279 18.0231Z"
        stroke="black"
        strokeWidth="2"
      />
      <rect x="31" y="24" width="2" height="13" rx="1" fill="black" />
      <rect x="30" y="39" width="4" height="4" rx="2" fill="black" />
    </SvgIcon>
  );
};
